import repository from './repository.js'

export default {
    /**
     * session情報取得API
     * @returns {Object}
     */
    async getUser() {
        return await repository.get('/user')
            .then(response => {
                return response.data.body
            })
            .catch(error => {
                console.log(error)
            })
    },

    /**
     * パスワード送信API
     * @param {Object} params
     * @return {Object}
     */
    async sendPassword(params) {
        return await repository.get('/user/password/send', {params})
            .then(response => {
                return response.data.body
            })
            .catch(error => {
                throw error
            })

    },

    /**
     * 認証API
     * @param {Object} params
     * @returns {Object}
     */
    async postLogin(params) {
        return await repository.post('/login', params)
            .then(response => {
                return response.data.body
            })
            .catch(error => {
                throw error
            })
    },
    /**
     * ログアウトAPI
     */
    async postLogout() {
        return await repository.post('/logout')
            .then(response => {
                return response.data.body
            })
            .catch(error => {
                console.log(error)
            })
    },

    /**
     * 契約一覧取得
     * 
     * @param {Number} customerId
     */
    async getContracts(customerId) {
        return await repository.get(`/users/${customerId}/contracts`)
            .then(response => {
                return response.data.body
            })
            .catch(error => {
                console.log(error)
            })
    },

    /**
     * パスワード取得
     * 
     * @param {Number} customerId
     */
    async getPassword(customerId) {
        return await repository.get(`/users/${customerId}/password`)
            .then(response => {
                return response.data.body
            })
            .catch(error => {
                console.log(error)
            })
    },

    /**
     * パスワード更新
     * 
     * @param {Number} customerId
     */
    async putPassword(customerId, params) {
        return await repository.put(`/users/${customerId}/password`, params)
            .then(response => {
                return response.data.body
            })
            .catch(error => {
                console.log(error)
            })
    },
    
    /**
     * 請求書PDF ダウンロード
     * 
     * @param {Number} customerId
     * @param {Number} contractId
     */
    async downloadPdf(customerId, contractId) {
        return await repository.get(`/users/${customerId}/contracts/${contractId}/download`, 
            { 
                responseType: 'blob',
                onDownloadProgress: (progressEvent) => {
                    console.log(Math.round((progressEvent.loaded * 100) / progressEvent.total))
                }
            })
            .then(response => {
                return response
            })
            .catch(error => {
                console.log(error)
            })
    }
}